<template>
    <!-- 时间范围选择，因RangePicker这个搜索后重置有问题 -->
    <a-range-picker :show-time="{ defaultValue: arrayMonent }" :value="state.rangTime" @change="rangTimeChange"
        :format="format"></a-range-picker>
</template>
<script lang="ts" setup>
import { reactive, ref, onMounted, h, watch } from 'vue'
const emit = defineEmits(['update:value', 'change'])
import dayjs from 'dayjs'
const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
const format = 'YYYY-MM-DD HH:mm:ss'
const props = defineProps({
    value: {
        type: String,
        default: null
    }
})
const state = reactive<any>({
    rangTime: []
})
// 时间选择
const rangTimeChange = (val, str) => {
    let between_time = null
    if (val) {
        between_time = str.join(',')
    }
    emit('update:value', between_time)
    emit('change', between_time)
}
watch(
    () => props.value,
    (val) => {
        let array: any = []
        if (val) {
            array = val.split(',').map((item) => dayjs(item ? item : null, format))
        } else {
            array = []
        }
        state.rangTime = array
    },
    {
        deep: true,
        immediate: true
    }
)
</script>
